import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router/index'
import store from './store'
import qs from 'qs'
import wx from 'weixin-js-sdk'
import Vant from 'vant'
import 'vant/lib/index.less'
import '@/assets/style/index.less'
import {clearCookie, getCookie, removeCookie, setCookie} from "./utils/auth";
import {numToCny} from "./utils/numToCny";
import {addition,guid,DecimalFormat,dateTimeHalfAnHourFormatter,dateTimeHalfAnHourFilter,addMinutesHalfAnHourTime} from "./utils/utitiles";
import moment from 'moment'

Vue.use(Vant);
Vue.use(VueRouter);
Vue.prototype.$qs = qs;
Vue.prototype.getCookie = getCookie;
Vue.prototype.removeCookie = removeCookie;
Vue.prototype.clearCookie = clearCookie;
Vue.prototype.setCookie = setCookie;
Vue.prototype.moment = moment;
Vue.prototype.numToCny = numToCny;
Vue.prototype.addition = addition;
Vue.prototype.guid = guid;
Vue.prototype.DecimalFormat=DecimalFormat;
Vue.prototype.dateTimeHalfAnHourFormatter=dateTimeHalfAnHourFormatter;
Vue.prototype.dateTimeHalfAnHourFilter=dateTimeHalfAnHourFilter;
Vue.prototype.addMinutesHalfAnHourTime=addMinutesHalfAnHourTime;
Vue.prototype.$wx = wx;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
